import { Screen, StackScreenProps } from '@rahtab/stack-navigator';
import { Colors, Text } from '@rahtab/ui';
import React, { useEffect, useState, VFC } from 'react';
import { Camera } from 'expo-camera';
import QRScanIcon from '@rahtab/ui/dist/icons/QRScanIcon';
import { StyleSheet, View } from 'react-native';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { RootStackType } from '../Router';
import * as yup from 'yup';
import { rahtabCardId } from '@rahtab/ui';

const schema = yup.object().shape({
  rahtabCardId,
});

const QRScanner: VFC<QRScannerProps> = ({ navigation: { navigate } }) => {
  const [hasPermission, setHasPermission] = useState<boolean | null>(null);
  useEffect(() => {
    (async () => {
      const { status } = await Camera.requestPermissionsAsync();
      setHasPermission(status === 'granted');
    })();
  }, []);
  if (hasPermission === false) {
    console.log('permissionFalse', hasPermission);
    return <Text style={{ textAlign: 'center' }}>دسترسی به دوربین وجود ندارد.</Text>;
  }
  console.log('permission', hasPermission);
  const handleBarCodeScanned = ({ type, data }: BarcodeScannerProps) => {
    navigate('Home', { qrData: data });
  };
  const validateRahtabCardId = (barcode: BarcodeScannerProps) => {
    schema
      .validate(
        {
          rahtabCardId: barcode.data,
        },
        { abortEarly: false },
      )
      .then(() => {
        handleBarCodeScanned(barcode);
      });
  };
  return (
    <Screen
      title="بارکدخوان رهتاب کارت"
      renderMain={() => {
        return (
          <>
            <Camera
              style={{ flex: 1 }}
              onBarCodeScanned={validateRahtabCardId}
              barCodeScannerSettings={{ barCodeTypes: ['qr', 'upc_e'] }}>
              <View style={styles.main}>
                <Text variant="cardTitle" color="white">
                  بارکد رهتاب کارت را اسکن کنید.
                </Text>
              </View>
              <View style={styles.scanner}>
                <View style={styles.main} />
                <QRScanIcon style={styles.image} />
                <View style={styles.main} />
              </View>
              <View style={styles.main} />
            </Camera>
          </>
        );
      }}
    />
  );
};
export default QRScanner;

const styles = StyleSheet.create({
  main: {
    flex: 1,
    backgroundColor: Colors.darkGray,
    opacity: 0.6,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  scanner: {
    flexDirection: 'row',
  },
  image: {
    alignSelf: 'center',
    width: 210,
    height: 210,
    margin: -5,
    zIndex: 5,
  },
});

interface QRScannerProps extends StackScreenProps<RootStackType> {}
interface BarcodeScannerProps {
  type: string;
  data: string;
}
